import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/splash.vue'
import LevelTestSplash from '../views/LevelTest/splash_page.vue'
import Evaluation2 from '../views/LevelTest/evaluations/evaluationform.vue'
import PrevieMaterial from '../views/LevelTest/levels/previewMaterial.vue'
import FeedBackStudentNew from '../views/LevelTest/students/forms/feedbackformNew.vue'
import LevelTestForm from '../views/LevelTest/Form/forms/LevelTestForms.vue'
import RCForm from '../views/RegularClass/forms/regular-class-form.vue'
import RCEvaluation from '../views/RegularClass/evaluations/StudentEvaluationNew.vue'
import Rating from '../views/MonitoringRating/Rating/rating.vue'
import ExcelAverage from '../components/MonitoringRating/excelReportMonthlyAverage.vue'
import TutorsMonthlyPerformance from '../views/MonitoringRating/Rating/tutorMonthlyPerformance.vue'
import perfRF from '../components/MonitoringRating/Performance/performanceFR.vue'
import classHandling from '../components/MonitoringRating/Performance/classHandling.vue'
import studentRetention from '../components/MonitoringRating/Performance/studentRetention/studentRetentionReport.vue'
import managerReview from '../components/MonitoringRating/Performance/managerReview/managerReview.vue'
import complaints from '../components/MonitoringRating/Performance/complaints/complaints.vue'
import attendanceIssue from '../components/MonitoringRating/Performance/attendanceIssue/attendanceIssue.vue'
Vue.use(VueRouter)

const routes = [{
        path: '/splash/:l_id/:s_id/:todate/:action?',
        name: 'Home',
        component: Home
    },
    {
        path: 'LevelTest/:l_id',
        name: 'LevelTestSplash',
        component: LevelTestSplash
    },
    {
        path: '/evaluation-new/:l_id',
        name: 'Evaluation2',
        component: Evaluation2
    }, {
        path: '/previewmaterial/:l_id',
        name: 'PreviewMaterial',
        component: PrevieMaterial
    }, {
        path: '/feedbackstudent/:l_id',
        name: 'feedbackformStudentNew',
        component: FeedBackStudentNew
    },
    {
        path: '/leveltestform/:l_id/:action?',
        name: 'leveltestform',
        component: LevelTestForm
    },
    {
        path: '/rcform/:s_id/:todate/:actionrc?',
        name: 'rcform',
        component: RCForm
    },
    {
        path: '/rcevaluation/:s_id/:todate',
        name: 'rcevaluation',
        component: RCEvaluation
    },
    {
        path: '/ratingmonitoring/:l_id?',
        name: 'ratingmonitoring',
        component: Rating
    },
    {
        path: '/excelmonitoring/:l_id?',
        name: 'excelmonitoring',
        component: ExcelAverage
    },
    {
        path: '/tutorMP/:l_id?',
        name: 'tutorMP',
        component: TutorsMonthlyPerformance
    },
    {
        path: '/perFR/:t_id/:mo',
        name: 'perFR',
        component: perfRF
    },
    {
        path: '/classHandling/:t_id/:mo',
        name: 'classHandling',
        component: classHandling
    },
    {
        path: '/studentRetention/:t_id?',
        name: 'studentRetention',
        component: studentRetention
    },
    {
        path: '/managerReview/:t_id?',
        name: 'managerReview',
        component: managerReview
    },
    {
        path: '/complaints/:t_id?',
        name: 'complaints',
        component: complaints
    },
    {
        path: '/attendanceIssue/:t_id?',
        name: 'attendanceIssue',
        component: attendanceIssue
    },


]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router